import f3tch from 'f3tch';

import API_URL from '../../constants/url.constant.api';
import profile from '../../profiles/json.profile.api';

const updateNotificationApi = (id, data = {}) =>
  f3tch(`/notifications/${id}`)
    .profile(profile({url: API_URL()}))
    .body(data)
    .patch();

export default updateNotificationApi;
